// import {
//     Button,
//     Grid,
// } from '@material-ui/core';
import { Form, Formik, FormikConfig, FormikValues } from 'formik';
import React from 'react';

export interface FormikStepProps
    extends Pick<FormikConfig<FormikValues>, 'children' | 'validationSchema'> {
}

export function FormikStep({ children }: FormikStepProps) {
    return <>{children}</>;
}
interface IFormikProps extends FormikConfig<FormikValues> {
    handleStepChange?: (values: any) => void;
}

const FormikForm = ({ children, handleStepChange, ...props }: IFormikProps) => {
    const currentChild = children as React.ReactElement<FormikStepProps>;
    return (
        <Formik
            {...props}
            validationSchema={currentChild.props.validationSchema}
            onSubmit={async (values, helpers) => {
                await props.onSubmit(values, helpers);
            }}
        >
            <Form autoComplete="off" style={{ margin: 2 }}>
                {children}
            </Form>
        </Formik>
    );
};

export default FormikForm;
